(function() {
  var repositioned = false;
  var attempts = 0;
  var observer = null;

  function reposition() {
    attempts++;
    
    if (repositioned) return true;

    const chart = document.querySelector('.ks-chart-container');
    const label = document.querySelector('[data-tooltip="sizechart"]');

    if (!label) {
      return false;
    }

    if (!chart) {
      return false;
    }

    // Success - reposition the chart
    label.appendChild(chart);

    repositioned = true;
    if (observer) observer.disconnect();
    return true;
  }

  function retry() {
    if (reposition()) {
      return;
    }
    
    if (attempts >= 3) {
      console.log('[Kiwi] Failed after 3 attempts');
      if (observer) observer.disconnect();
      return;
    }
    
    setTimeout(retry, attempts * 1000);
  }

  // MutationObserver to detect Kiwi elements added to DOM
  observer = new MutationObserver(function(mutations) { 
    if (repositioned) {
      observer.disconnect();
      return;
    }
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (
            node.classList.contains('ks-chart-container') ||
            node.classList.contains('ks-calculator-container') ||
            (node.querySelector && node.querySelector('.ks-chart-container, .ks-calculator-container'))
        )) {
          reposition();
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  retry();
})();
